<style lang="scss" scoped>
    .home_post {
        .card {
            cursor: pointer;
        }
        .card-text {
            font-weight: lighter;
        }
    }
</style>


<template>
    <div>
        <div class="text-center">
            <img src="../../assets/logo.svg" alt="DeepLOV">
            <div class="lead mt-4">{{ $t('global.catchPhrase') }}</div>
        </div>
        <div class="text-center mt-4">
            <router-link
                    v-if="!logged"
                    class="btn btn-primary"
                    :to="{name: 'AppAbout'}"
            >{{ $t('index.discover') }}
            </router-link>
            <router-link v-if="logged" class="btn btn-primary" :to="{name: 'QuestionShowCurrent'}">
                <font-awesome-icon icon="play"/>
                {{$t('global.menu.questions.continue')}}
            </router-link>
        </div>
        <h2 class="mt-3">
            <font-awesome-icon icon="newspaper"/>
            {{ $t('index.title') }}
        </h2>
        <div class="card-columns home_post">
            <router-link
                    v-for="item in items"
                    :key="item.id"
                    class="card"
                    tag="div"
                    :to="{name: 'PostShow', params: { id: item['@id'] }}"
            >
                <div class="card-body" v-if="item">
                    <h5 class="card-title">{{ item['title'] }}</h5>
                    <p class="card-text">{{ removeMarkdown(item['description']) | ellipsis(300) }}</p>
                    <footer class="blockquote-footer text-right">
                        <small class="text-muted">{{ item['createDate'] | formatDate }}</small>
                    </footer>
                </div>
            </router-link>
        </div>
        <ShowMorePage v-bind:view="view" v-bind:getPage="getPage"></ShowMorePage>
    </div>
</template>


<script>
    import {mapActions, mapGetters} from 'vuex';
    import ellipsis from '../../filters/ellipsis';
    import ShowMorePage from './ShowMorePage';

    export default {
        components: {ShowMorePage},
        filters: {
            ellipsis,
        },
        computed: mapGetters({
            logged: 'user/auth/logged',
            items: 'post/list/items',
            loading: 'loading/loading/loading',
            view: 'post/list/view',
            isGiveAway: 'app/giveAway/isGiveAway',
        }),
        methods: {
            removeMarkdown: require('remove-markdown'),
            ...mapActions({getPage: 'post/list/getItems'}),
        },
        created() {
            this.$store.dispatch('post/list/resetItems');
            if (this.logged) {
                this.$store
                    .dispatch('app/giveAway/getGiveAwayQuestion')
                    .then(() => {
                        if (this.isGiveAway) {
                            this.$emit('giveAway');
                        }
                    });
            }
        },
        beforeDestroy() {
            this.$store.dispatch('post/list/reset');
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/post/List.vue